let pixelLoaded = false;

export function initMetaPixels(pixelIds, { skipPageView = false } = {}) {
  const ids = (pixelIds || []).filter(Boolean);
  if (ids.length === 0 || typeof window === "undefined") return;
  if (!pixelLoaded) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    pixelLoaded = true;
  }
  ids.forEach((id) => window.fbq("init", id));
  if (!skipPageView) {
    window.fbq("track", "PageView");
  }
}

export function trackPixelEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("trackCustom", eventName, params);
  }
}

export function trackStandardPixelEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", eventName, params);
  }
}

// Fires a custom event scoped to ONE specific pixel ID only (not broadcast to every
// init'd pixel on the page like trackCustom does). The pixelId must already be
// `init`'d — see ensurePixelInitialized() below — for Meta to accept the event.
export function trackSinglePixelCustomEvent(pixelId, eventName, params = {}) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("trackSingleCustom", pixelId, eventName, params);
  }
}

// Registers an extra pixel ID with fbq (idempotent) without re-broadcasting PageView,
// for cases where a conversion event must fire to a fixed pixel regardless of whether
// the page owner configured it in their own meta_pixels list.
export function ensurePixelInitialized(pixelId) {
  initMetaPixels([pixelId], { skipPageView: true });
}
